enum PackageSize {
    xsmall = 'xsmall',
    small = 'small',
    medium = 'medium',
    large = 'large',
    xlarge = 'xlarge',
}

export default PackageSize;
